export const dataTables = {
  methods: {
    dateSort: function(a, b) {
      return new Date(this.readableToStandard(a, "/")) - new Date(this.readableToStandard(b, "/"))
    },
    numberSort: function(a, b) {
      if (isNaN(a)) {
        a = 0;
      }
      if (isNaN(b)) {
        b = 0;
      }
      return a - b
    },
    readableToStandard(date, splitter = "-") {
      if (!date) {
        return null;
      }
      const dateArr = date.split(splitter);

      return dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
    },
  },
};
